module.exports = __webpack_public_path__ + "img/Bingo2_Asset_Info_Web_2.7dd08ed6.png";